import {TimelineMax, TweenMax, Sine} from 'gsap';
const Storage = require('../../load/Storage');
const svgStorage = Storage.instance();

module.exports = (name, el, numLayers = 1) => {
    const Behavior = {
        el: el
    };

    const _init = function(behavior, name) {
        const item = svgStorage.getItem(name);
        if (!item || !item.node) return behavior;
        behavior.el.appendChild(item.node);

        behavior._tl = new TimelineMax({
            onUpdate: behavior => {
                if (behavior._started) behavior._onEnterFrame();
            },
            onUpdateParams: [behavior]
        });

        const el0 = [];
        let i;
        for (i = 0; i < numLayers; i++) {
            el0.push(item.node.querySelector(`#${name}_0_bg_layer_${i}`));
        }

        const el1 = [];
        for (i = 0; i < numLayers; i++) {
            el1.push(item.node.querySelector(`#${name}_1_bg_layer_${i}`));
        }

        const el2 = [];
        for (i = 0; i < numLayers; i++) {
            el2.push(item.node.querySelector(`#${name}_2_bg_layer_${i}`));
        }

        TweenMax.set(el0, {opacity: 1});
        TweenMax.set([el1, el2], {opacity: 0});

        behavior._tl.set(el0, {opacity: 1});
        behavior._tl.set([el1, el2], {opacity: 0});
        behavior._tl.addLabel('st');
        behavior._tl.to(el1, 0.25, {opacity: 1}, 'st+=2');
        behavior._tl.set(el0, {opacity: 0}, 'st+=2.26');
        behavior._tl.to(el2, 0.25, {opacity: 1}, 'st+=3');
        behavior._tl.set(el1, {opacity: 0}, 'st+=3.26');

        behavior._onEnterFrame = () => {
            behavior._update();
            behavior.onUpdate();
        };

        behavior.play = () => {
            if (behavior._tweenTl) behavior._tweenTl.kill();
            behavior.__stopLoop();
            behavior._started = true;
            behavior._tl.play();
        };

        behavior.gotoAndStop = frame => {
            if (behavior._tweenTl) behavior._tweenTl.kill();
            behavior.__stopLoop();
            behavior._started = true;
            behavior._tl.seek(frame);
        };

        behavior.playFromTo = (from, to) => {
            return new Promise(resolve => {
                if (behavior._tweenTl) behavior._tweenTl.kill();
                behavior.__stopLoop();
                behavior._started = true;
                behavior._tl.tweenFromTo(from, to, {onComplete: resolve, onCompleteParams: [true]});
            });
        };

        behavior.tweenFromTo = (from, to, duration, ease) => {
            return new Promise(resolve => {
                if (behavior._tweenTl) behavior._tweenTl.kill();
                behavior.__stopLoop();
                behavior._started = true;
                behavior._tl.pause();

                behavior._tweenTl = new TimelineMax();
                behavior._tweenTl.to({t: from}, duration, {
                    t: to,
                    onUpdate: function() {
                        behavior._tl.time(this.target.t);
                    },
                    onComplete: resolve,
                    onCompleteParams: [true],
                    ease: ease || Sine.easeOut
                });
            });
        };

        behavior.waitForLoopComplete = () => {
            return new Promise(resolve => {
                if (!behavior._loopMode) {
                    resolve();
                    return;
                }

                behavior._loopStop = true;
                behavior._loopStopResolve = resolve;
            });
        };

        behavior.loopFromTo = (from, to) => {
            if (behavior._tweenTl) behavior._tweenTl.kill();
            behavior.__stopLoop();
            behavior._started = true;
            behavior._loopMode = true;
            behavior._loopStop = false;
            behavior._loopTl = behavior._tl.tweenFromTo(from, to, {
                onComplete: (from, to) => {
                    if (behavior._loopStop) {
                        if (behavior._loopTl) {
                            behavior._loopTl.kill();
                            behavior._loopTl = null;
                        }
                        behavior._loopMode = false;
                        behavior._loopStop = false;
                        behavior._loopStopResolve();
                        return;
                    }

                    behavior.loopFromTo(from, to);
                },
                onCompleteParams: [from, to]
            });
        };

        behavior.__stopLoop = () => {
            if (behavior._loopTl) {
                behavior._loopTl.kill();
                behavior._loopTl = null;
            }
            behavior._loopMode = false;
            behavior._loopStop = false;
            behavior._loopStopResolve = undefined;
        };

        behavior.stop = () => {
            if (behavior._tweenTl) behavior._tweenTl.kill();
            behavior.__stopLoop();
            behavior._tl.pause();
            behavior._started = false;
            behavior._loopMode = false;
            behavior._loopStop = false;
            behavior._loopStopResolve = undefined;
        };

        behavior.destroy = () => {
            if (behavior._tweenTl) behavior._tweenTl.kill();
            behavior.__stopLoop();
            behavior._tl.kill();
            behavior.el.innerHTML = '';
            behavior._started = false;
            behavior._loopMode = false;
            behavior._loopStop = false;
            behavior._loopStopResolve = undefined;
        };
    };

    Behavior.init = () => {
        _init(Behavior, name);
    };
    Behavior.play = () => {};
    Behavior.gotoAndStop = () => {};
    Behavior.playFromTo = () => {};
    Behavior.waitForLoopComplete = () => {};
    Behavior.loopFromTo = () => {};
    Behavior.stop = () => {};
    Behavior.destroy = () => {};
    Behavior._update = () => {};
    Behavior.onUpdate = () => {};

    return Behavior;
};
